// "QA Test Bakery" -> "qatestbakery". Web addresses are letters, numbers and
// hyphens only; a typed extension (".com") is kept.
export function normalizeDomainQuery(raw) {
  let v = String(raw || '').trim().toLowerCase().replace(/^https?:\/\//, '').replace(/^www\./, '').split('/')[0];
  const dot = v.indexOf('.');
  let name = dot >= 0 ? v.slice(0, dot) : v;
  let ext = dot >= 0 ? v.slice(dot + 1).replace(/[^a-z0-9.]/g, '') : '';
  name = name.replace(/[^a-z0-9-]/g, '').replace(/^-+|-+$/g, '');
  if (!name) return '';
  return ext ? `${name}.${ext}` : name;
}

